import React from 'react'
import { Formik } from 'formik'
import { IsDisabledContext } from '../../../../../model/context/IsDisabledContext'
import { ProjectFormEnum } from 'shared'
import { AccompanyingReportFields } from '../AccompanyingReportFields'

interface Props {
  formValues: any
  projectForm: ProjectFormEnum
}

export const AccompanyingReportFakeAIForm: React.FC<Props> = (props) => {
  return (
    <div>
      <Formik initialValues={props.formValues} onSubmit={() => {}} enableReinitialize={true}>
        <IsDisabledContext.Provider value={true}>
          <AccompanyingReportFields projectForm={props.projectForm} />
        </IsDisabledContext.Provider>
      </Formik>
    </div>
  )
}
